import { FC, useEffect, useState } from 'react'
import { AnimatePresence } from 'framer-motion'

import { Word as WordType } from 'models'
import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'
import { IconShare } from 'components/icons/share'
import { useAppContext } from 'context/app-context'
import { IconClose } from 'components/icons/close'
import { IconDownload } from 'components/icons/download'
import {
  CenterContent,
  Container,
  Description,
  Dl,
  Header,
  Share,
  ShareToggle,
  Social,
  Title,
} from './styled'

type Props = {
  word: WordType
  blob: Blob | null
}

export const Reverse: FC<Props> = ({ word, blob }) => {
  const { colors } = useAppContext()
  const [isExpanded, setExpanded] = useState(false)
  const [downloadUrl, setDownloadUrl] = useState('')
  const isMobile = useMedia([breakpoints.smallOnly], [true], false)

  useEffect(() => {
    setDownloadUrl(blob ? URL.createObjectURL(blob) : '')
  }, [blob])

  const handleClick = () => {
    if (
      typeof navigator !== 'undefined' &&
      typeof navigator.share === 'function' &&
      blob
    ) {
      const file = new File([blob], 'tatar-dictionary-share.png', {
        type: 'image/png',
      })

      navigator.share({
        files: [file],
      })
    } else {
      setExpanded(v => !v)
    }
  }

  return (
    <>
      <Container
        as="span"
        $variant="reverse"
        $color={
          colors && word.category in colors
            ? colors[word.category as keyof typeof colors]
            : ''
        }
      >
        <Share
          layout
          $expanded={isExpanded}
          style={{ borderBottomLeftRadius: isMobile ? 24 : 48 }}
        >
          <AnimatePresence mode="popLayout">
            {isExpanded && (
              <Social
                layout
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                {!!downloadUrl && (
                  <a
                    href={downloadUrl}
                    download={`tatar-dictionary-${word.tatar}.png`}
                  >
                    <IconDownload />
                  </a>
                )}
                <button onClick={handleClick}>
                  <IconClose />
                </button>
              </Social>
            )}
          </AnimatePresence>

          <AnimatePresence mode="popLayout">
            {!isExpanded && (
              <ShareToggle
                layout
                onClick={handleClick}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <IconShare />
              </ShareToggle>
            )}
          </AnimatePresence>
        </Share>

        <Header $visible={!isExpanded}>
          <span>#{word.category}</span>
        </Header>

        <CenterContent>
          <Title hyphens={!word.tatar.includes(' ')}>
            <span>
              <span>{word.tatar}</span>
            </span>
          </Title>

          <Description>{word.description}</Description>
        </CenterContent>

        <Dl>
          <dt>english: </dt>
          <dd>{word.english}</dd>
          <dt>Русский: </dt>
          <dd>{word.russian}</dd>
        </Dl>
      </Container>
    </>
  )
}
